<template>
  <svg
    id="icon-list"
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    fill="none"
    viewBox="0 0 20 16"
  >
    <path
      :fill="fill"
      d="M6.196 3.218a.975.975 0 0 1-.705-.279.975.975 0 0 1-.278-.705.964.964 0 0 1 .983-.983h12.552c.273 0 .505.096.696.287a.948.948 0 0 1 .288.696.964.964 0 0 1-.983.983H6.195Zm0 5.76a.964.964 0 0 1-.983-.983c0-.272.093-.5.278-.686a.959.959 0 0 1 .705-.288h12.552c.273 0 .505.096.696.288a.917.917 0 0 1 .288.686.964.964 0 0 1-.983.983H6.195Zm0 5.762a.976.976 0 0 1-.705-.278.976.976 0 0 1-.278-.705.964.964 0 0 1 .983-.984h12.552c.273 0 .505.096.696.288a.948.948 0 0 1 .288.696.964.964 0 0 1-.983.983H6.195ZM1.678 3.635c-.39 0-.723-.136-1.002-.408a1.351 1.351 0 0 1-.408-.993c0-.39.136-.72.408-.993A1.382 1.382 0 0 1 1.678.833c.384 0 .715.136.993.408.278.273.417.603.417.993s-.139.72-.417.993c-.278.272-.61.408-.993.408Zm0 5.77c-.39 0-.723-.139-1.002-.417a1.371 1.371 0 0 1-.408-.993c0-.383.136-.714.408-.992a1.366 1.366 0 0 1 1.002-.418c.384 0 .715.14.993.418.278.278.417.609.417.992 0 .384-.139.715-.417.993-.278.278-.61.418-.993.418Zm0 5.762c-.39 0-.723-.14-1.002-.418a1.351 1.351 0 0 1-.408-.992c0-.39.136-.72.408-.993a1.382 1.382 0 0 1 1.002-.408c.384 0 .715.136.993.408.278.272.417.603.417.993s-.139.72-.417.992c-.278.279-.61.418-.993.418Z"
    />
  </svg>
</template>

<script>
import { iconPropsFunc } from "./mixins/icons";

export default {
  name: "IconList",
  mixins: [iconPropsFunc()],
};
</script>

<style lang="scss" scoped></style>
